<p-dialog
	[(visible)]="showImageCropper"
	[closable]="false"
	[closeOnEscape]="false"
	[baseZIndex]="10000"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '75vw' }"
>
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'camera']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">{{ imgCrop.imageCropperHeader }}</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<div class="d-flex display-10">Image specifications:</div>
	<div class="d-flex ms-3 mt-1 display-12">{{ imgCrop.imageDimensionDetail }}</div>
	<div class="p-3 border-bottom">
		<input *ngIf="imgCrop.showImageCropper" #imageCropperFileInput type="file" (change)="imgCrop.onImageFileChange($event)" />
	</div>
	<div class="d-flex align-items-center justify-content-center">
		<div class="mx-auto my-3" style="width: 450px">
			<img *ngIf="imgCrop.imageCropperSrc && !imgCrop.imageChangedEvent" class="w-100" [src]="imgCrop.imageCropperSrc" onError="this.src=''" />
			<image-cropper
				*ngIf="imgCrop.imageChangedEvent"
				[imageChangedEvent]="imgCrop.imageChangedEvent"
				[maintainAspectRatio]="false"
				[cropperMinHeight]="imgCrop.imageCropperMinHeight"
				[cropperMinWidth]="imgCrop.imageCropperMinWidth"
				[cropperMaxHeight]="imgCrop.imageCropperMaxHeight"
				[cropperMaxWidth]="imgCrop.imageCropperMaxWidth"
				[aspectRatio]="imgCrop.imageCropperAspect"
				format="png"
				(imageCropped)="imgCrop.onImageCropped($event)"
				(imageLoaded)="onImageLoad($event)"
			></image-cropper>
		</div>
	</div>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]=""
			(onCancelChange)="imgCrop.closeImageCropper()"
			(onSaveChange)="imgCrop.saveImage(imgCrop.imageCropped, venueKey); onImageComplete()"
			[saveDisabled]="!imageLoaded"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
